import { CalculatorDescription } from '../../../lib/calculators/calculator-description';
import { CalculatorId } from '../../../lib/calculators/calculator-config';

export const criticalValueDescription: CalculatorDescription = {
  id: CalculatorId.CRITICAL_VALUE,
  title: 'Critical Value Calculator',
  metaTitle: 'Critical Value Calculator - Find Statistical Test Critical Values',
  description: 'Calculate critical values for various statistical distributions including Normal, t, Chi-square, and F distributions.',
  metaDescription: 'Free online critical value calculator for Normal, t, Chi-square, and F distributions. Find critical values for hypothesis testing with customizable significance levels.',
  howTo: {
    title: 'How to use the Critical Value Calculator',
    steps: [
      'Select the type of distribution (Normal, t, Chi-square, or F)',
      'Enter the significance level (α)',
      'For t, Chi-square, and F distributions, specify the degrees of freedom',
      'Choose whether the test is one-tailed or two-tailed (for Normal and t distributions)',
      'The calculator will display the critical value and its interpretation'
    ]
  },
  examples: [
    {
      title: 'Two-tailed Z-test Critical Value',
      description: 'Finding critical values for a two-tailed Z-test with α = 0.05',
      dataDescription: 'Using the standard normal distribution with 5% significance level',
      insights: [
        'For α = 0.05 in a two-tailed test, the critical z-value is approximately ±1.96',
        'This means we reject the null hypothesis if |Z| > 1.96',
        'The area in each tail is 0.025 (α/2)'
      ]
    },
    {
      title: 'Chi-square Critical Value',
      description: 'Finding the critical value for a chi-square test with 4 degrees of freedom',
      dataDescription: 'Using α = 0.05 and df = 4',
      insights: [
        'The critical value is approximately 9.488',
        'Reject the null hypothesis if the chi-square statistic exceeds 9.488',
        'This is a right-tailed test, so we only look at the upper tail'
      ]
    }
  ],
  relatedCalculators: [
    CalculatorId.CHI_SQUARE,
    CalculatorId.NORMAL_DISTRIBUTION,
    CalculatorId.Z_SCORE
  ]
}; 